import type { ReactNode } from 'react';
import * as React from 'react';

import type { DatumValue } from '@nivo/line';

interface ChartTooltipProps {
  label: DatumValue;
  legend?: ReactNode | string;
  value: DatumValue | ReactNode;
}

const ChartTooltip: React.FC<ChartTooltipProps> = ({
  label,
  value,
  legend,
}) => {
  // Ensure none of the values are functions (which can't be rendered as React children)
  const displayLabel = typeof label === 'function' ? String(label) : label;
  const displayLegend = typeof legend === 'function' ? String(legend) : legend;
  const displayValue = typeof value === 'function' ? String(value) : value;

  return (
    <div className="chart-tooltip">
      {/* @ts-expect-error - label type mismatch */}
      <div className="chart-tooltip-label">{displayLabel}</div>
      <div className="chart-tooltip-value">
        <div className="chart-tooltip-value-legend">{displayLegend}</div>
        {/* @ts-expect-error - value type mismatch */}
        <span className="chart-tooltip-value-text">{displayValue}</span>
      </div>
    </div>
  );
};

export default ChartTooltip;
